export enum BfxProtocolType {
  ORDER,
  RFQ,
}
